import Service from "../tools/service";

class PaymentsService extends Service {
  constructor(professional_id) {
    super(`/professionals/${professional_id}/payments`);
  }

  async uploadProof(id, file) {
    const payload = new FormData();
    payload.append("proof", file);

    const response = await this.http.post(`${this.path}/${id}/proof`, payload);

    return response.data;
  }

  async uploadInvoice(id, file) {
    const payload = new FormData();
    payload.append("invoice", file);

    const response = await this.http.post(
      `${this.path}/${id}/invoice`,
      payload
    );

    return response.data;
  }
}

export default PaymentsService;
